import {Component,Inject,Input,OnDestroy,OnInit,PLATFORM_ID,ViewChild,} from "@angular/core";
import { Store } from "@ngrx/store";
import { _seoContent } from "@app/marketplace/seo-content/utils";
import { Observable, Subscription } from "rxjs";
import * as actions from '../state/shopping-cart/cart-action';
import * as selectors from '../state/shopping-cart/cart-selectors';
import { ShippingTypeEnum } from "@app/marketplace/core/enum/shippingType";
import { MarketProduct } from "../_models/product.interface";
import { ViewTypeEnum } from "@app/marketplace/core/enum/viewTypeEnum";
@Component({
  selector: "app-shopping-shipping",
  templateUrl: "./shopping-shipping.component.html",
  styleUrls: ["./shopping-shipping.component.css"],
})
export class ShoppingShippingComponent  implements OnInit, OnDestroy {
  @Input() product: MarketProduct;
  shippings$ :Observable<any>;
  selectedShippingType$: Observable<any>;
  constructor(private store: Store<any>) {;}
  ngOnInit(): void {
    this.shippings$ = this.store.select(selectors.selectShippings(this.product));
    this.selectedShippingType$=this.store.select(selectors.selectShippingType(this.product));
  }
 setShippingType=(shipping:ShippingTypeEnum)=>{
   this.store.dispatch(actions.SetShippingType({product:this.product,shipping,viewType:ViewTypeEnum.ShoppingCart}));
  }
  ngOnDestroy(): void {;}
}
